module.exports = __webpack_public_path__ + "static/media/comunicacion.b6eef5b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/comunicacion.svg
// module id = 196
// module chunks = 0